import { render, staticRenderFns } from "./PartnerTheme.vue?vue&type=template&id=500c5591"
import script from "./PartnerTheme.vue?vue&type=script&lang=ts"
export * from "./PartnerTheme.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports